import React, { useEffect, useRef, useState } from 'react';
import { Network } from '@capacitor/network';
import { Transition } from 'react-transition-group';
import './OfflinePanel.css';
import Message from '../Message/Message';

const transitionStyles = {
  entering: { transform: 'translateY(0%)' },
  entered: { transform: 'translateY(0%)' },
  exiting: { transform: 'translateY(calc(-100% - 0.75rem))' },
  exited: { transform: 'translateY(calc(-100% - 0.75rem))' },
};

const OfflinePanel = () => {
  const nodeRef = useRef(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    Network.addListener('networkStatusChange', handleStatusChange);
    return () => {
      Network.removeAllListeners();
    };
  }, []);
  return (
    <Transition
      nodeRef={nodeRef}
      in={!isOnline}
      timeout={200}
      mountOnEnter
      unmountOnExit
    >
      {(state) => (
        <div
          className="offlinePanel"
          ref={nodeRef}
          style={transitionStyles[state]}
        >
          <Message id="youAreOffline" />
        </div>
      )}
    </Transition>
  );
};

export default OfflinePanel;
